import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a68097d00ee1e00144f61a5_1785256125210_45a6c122/lucatfamille/src/app/agenda/components/AgendaClient.tsx");
